import { Flex, Icon, Link, Menu, MenuButton, Text } from '@chakra-ui/react';
import React, { Component } from 'react';
import { Link as ReactLink } from "react-router-dom";



export default class SubNavItem extends Component {
    state = {

    }
    render() {
        return (
            <div>
                <Flex
                    flexDir="column"
                    w="100%"
                    hidden={this.props.navSize === "small"}
                    alignItems={this.props.navSize === "small" ? "center" : "flex-start"}
                    backgroundColor="#135255"
                    mt="2px"
                >
                    <Menu placement="right">
                        <Flex w="100%" alignItems={"center"} onClick={() => { sessionStorage.clear(); }}>
                            <Flex display={this.props.active ? "flex" : "none"} w={1} borderRightRadius={5} position="absolute" h="40px" backgroundColor={this.props.active && "#0A3739"} />
                            <Link
                                as={ReactLink}
                                backgroundColor={this.props.active ? "#1C797E" : "#006E74"}
                                _hover={{ textDecoration: "none", backgroundColor: "#1C797E" }}
                                w={this.props.navSize === "large" && "100%"}
                                py={4}
                                to={this.props.href}
                            >

                                <MenuButton w="100%" >
                                    <Flex justifyContent="flex-start" alignItems="center" ml={16} gap={2}>
                                        {this.props.icon && <Icon as={this.props.icon} fontSize="xl" color={this.props.active ? "white" : "white"} />}
                                        <Text
                                            color={"white"}
                                            display={this.props.navSize === "small" ? "none" : "block"}
                                            textAlign="left"
                                        >
                                            {this.props.title}
                                        </Text>
                                    </Flex>
                                </MenuButton>
                            </Link>

                        </Flex>
                    </Menu>
                </Flex>
            </div>
        )
    }
}
